import React, { useEffect } from 'react';
import { useDeviceSize } from '@atlassian/learning-components';

interface ScrollLockProps {
  isSidebarVisible: boolean;
}

export const ScrollLock: React.FC<ScrollLockProps> = ({ isSidebarVisible }) => {
  const deviceWidth = useDeviceSize();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.body.style.overflow = isSidebarVisible && deviceWidth <= 1200 ? 'hidden' : '';
    }
  }, [deviceWidth, isSidebarVisible]);

  return null;
};
